import styled from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

export const Group = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]};
`;

export const GroupLabel = styled.span`
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Chip = styled.label<{ $checked: boolean; $disabled: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  min-height: 2rem;
  padding: 0 ${spacing[2]};
  border: 1px solid ${({ theme, $checked }) => ($checked ? theme.colors.primary[200] : theme.colors.border.stroke)};
  border-radius: ${borderRadius.lg};
  background: ${({ theme, $checked }) => ($checked ? theme.colors.primary[100] : theme.colors.surface.primary)};
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:focus-within {
    outline: 2px solid ${({ theme }) => theme.colors.primary[500]};
    outline-offset: ${spacing[0.5]};
  }

  input {
    margin: 0;
    accent-color: ${({ theme }) => theme.colors.primary[500]};
  }
`;

export const Mono = styled.span`
  ${typographyMixin("code", "small")}
`;

export const Hint = styled.span`
  ${typographyMixin("code", "small")}
  color: ${({ theme }) => theme.colors.text.secondary};
`;
